











import { Component, Prop, Vue } from "vue-property-decorator";
import { ChartElement } from "@/typescript/packages/apexcharts/index";
import { ApexOptions } from "apexcharts";
export { ChartElement, ApexOptions };

@Component
export default class LineChartComponent extends Vue {
  chartId: string = "line_chart";
  errorLineStyle: { color: string } = { color: "#F44436" };

  @Prop()
  chartOptions!: ApexOptions;

  @Prop()
  series!: [];

  get internalChartOptions() {
    return this.chartOptions;
  }
}
